import { Tag } from "lucide-react";
import {
  BaseEntityCard,
  BaseEntityCardActions,
  BaseEntityCardBody,
  BaseEntityCardContent,
  BaseEntityCardContextMenu,
  BaseEntityCardDescription,
  BaseEntityCardExternalLinkAction,
  BaseEntityCardHeader,
  BaseEntityCardIcon,
  BaseEntityCardMentionAction,
  BaseEntityCardProps,
  BaseEntityCardTitle,
} from "../BaseCard";

export interface Label {
  id: number;
  node_id: string;
  url: string;
  name: string;
  description?: string;
  color: string;
  default: boolean;
}

type LabelCardProps = Label & BaseEntityCardProps;

export function LabelCardAvatar({
  color,
  className,
  style,
}: Partial<LabelCardProps>) {
  return (
    <BaseEntityCardIcon className={className} style={style}>
      <Tag
        className="h-5 w-5"
        style={{ color: color ? `#${color}` : undefined }}
      />
    </BaseEntityCardIcon>
  );
}

export function LabelCard({
  platform,
  name,
  description,
  color,
  default: isDefault,
  url,
  onClick,
  onDoubleClick,
  onMentionClick,
  actions,
  processes,
  className,
  style,
}: LabelCardProps) {
  return (
    <BaseEntityCard
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      processes={processes}
      className={className}
      style={style}
    >
      <LabelCardAvatar color={color} />

      <BaseEntityCardContent>
        <BaseEntityCardHeader>
          <BaseEntityCardTitle platform={platform}>
            <div className="flex items-center gap-2">
              <div
                className="w-3 h-3 rounded-full border "
                style={{ backgroundColor: color ? `#${color}` : "#gray" }}
              />
              {name}
            </div>
          </BaseEntityCardTitle>
          <BaseEntityCardActions>
            {url && (
              <BaseEntityCardExternalLinkAction
                href={url}
                tooltip="Open label"
              />
            )}
            {onMentionClick && (
              <BaseEntityCardMentionAction onClick={onMentionClick} />
            )}
            {actions && actions.length > 0 && (
              <BaseEntityCardContextMenu actions={actions} />
            )}
          </BaseEntityCardActions>
        </BaseEntityCardHeader>

        <BaseEntityCardBody>
          {description && (
            <BaseEntityCardDescription className="line-clamp-2 text-foreground">
              {description}
            </BaseEntityCardDescription>
          )}

          {isDefault && (
            <div className="text-xs text-muted-foreground">Default label</div>
          )}
        </BaseEntityCardBody>
      </BaseEntityCardContent>
    </BaseEntityCard>
  );
}
